<template>
  <div class="v-steps" :class="{ 'v-steps--vertical': vertical, 'v-steps--clickable': clickable }">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue'

import { $stepsKey } from '../../utils/injections.ts'

export interface Props {
  vertical?: boolean
  clickable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  vertical: false,
  clickable: true,
})

const model = defineModel<number>({ default: -1 })

defineSlots<{
  default?(): any
}>()

const steps = ref<number[]>([])

provide($stepsKey, {
  props,
  model,
  steps,
})

defineExpose({
  steps,
})
</script>

<style>
.v-steps {
  display: flex;
  position: relative;
  white-space: nowrap;
  justify-content: space-between;
  width: 100%;
}

.v-steps--vertical {
  height: 100%;
  flex-direction: column;
}
</style>
